
<div
	class="flow-env-status-card"
	:disabled="disabled"
	:state="state"
	@click="handleClick($event)"
>
	<slot />
</div>
